import { render } from "./SquadComponent.vue?vue&type=template&id=70a501d0&scoped=true"
import script from "./SquadComponent.vue?vue&type=script&lang=js"
export * from "./SquadComponent.vue?vue&type=script&lang=js"

import "./SquadComponent.vue?vue&type=style&index=0&id=70a501d0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a501d0"]])

export default __exports__